/**
 * Custom hook providing input transformation functions
 * Filters and formats user input to match validation rules
 */
export function useInputTransformers() {
  // Transform Flight Owner: uppercase only, allow typing freely
  const transformFlightOwner = (value: string): string => {
    return value.toUpperCase().slice(0, 3);
  };

  // Strict transform for Flight Owner on blur: remove invalid chars
  const strictTransformFlightOwner = (value: string): string => {
    return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
  };

  // Transform Flight Number: uppercase alphanumeric + space, max 10 chars
  const transformFlightNumber = (value: string): string => {
    return value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, 10);
  };

  // Transform Flight Number Digits: digits only, max 4 chars
  const transformFlightNumberDigits = (value: string): string => {
    return value.replace(/[^0-9]/g, '').slice(0, 4);
  };

  // Transform Operational Suffix: uppercase, max 1 char
  const transformSuffix = (value: string): string => {
    return value.toUpperCase().slice(0, 1);
  };

  // Transform Service Type: uppercase, max 1 char
  const transformServiceType = (value: string): string => {
    return value.toUpperCase().slice(0, 1);
  };

  // Transform Season ID: uppercase S/W + digits, max 3 chars
  const transformSeasonId = (value: string): string => {
    return value.toUpperCase().replace(/[^SW0-9]/g, '').slice(0, 3);
  };

  // Transform Codeshare: uppercase alphanumeric + space, max 10 chars
  const transformCodeshare = (value: string): string => {
    return value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, 10);
  };

  return {
    transformFlightOwner,
    strictTransformFlightOwner,
    transformFlightNumber,
    transformFlightNumberDigits,
    transformSuffix,
    transformServiceType,
    transformSeasonId,
    transformCodeshare,
  };
}
